import type { BaseVariantTypeForSorting } from "@sorcery/utils/universal/sorting";
import { getVariantTitle } from "@sorcery/utils/universal/variant";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../ui/select";
import { SetSymbol } from "../SetSymbol";

export const VariantSwitcher = ({
  variant,
  variants,
  onChange,
}: {
  variant: BaseVariantTypeForSorting;
  variants: BaseVariantTypeForSorting[];
  onChange: (id: string) => void;
}) => {
  return (
    <Select defaultValue={variant.id} onValueChange={onChange}>
      <SelectTrigger arrow className="w-fit min-w-[240px]">
        <SelectValue placeholder={getVariantTitle(variant)} />
      </SelectTrigger>
      <SelectContent>
        {variants.map((i) => (
          <SelectItem key={i.id} value={i.id}>
            <span className="flex items-center">
              <SetSymbol
                set={variant.setCard.set.code}
                product={variant.product}
                className="-mt-2"
              />

              {getVariantTitle(i)}
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
